import OrderModel from '../../../../../models/order';
import LzCrudListingClass from '../../../../commons/crud/listing.class';
import LzCrudListingComponent from '../../../../commons/crud/listing.component';
import PrivateLayout from '../../../../layouts/private';
import { crudConfig } from './crud-config';

class OrdersScreen extends LzCrudListingClass {

    constructor(props) {
        super(props, crudConfig, OrderModel);
    }

    render() {
        const { records, total, curPage, perPage, sortKey, sortDir, checkedIds, showDeleted } = this.state;

        return (
            <PrivateLayout screenTitle="Manage Your Orders">

                <LzCrudListingComponent
                    records={records}
                    config={crudConfig}
                    onRefresh={() => this.loadRecords()}
                    onActionIconClick={(key, rec) => this.handleActionIconClick(key, rec)}
                    onGroupActionIconClick={(key, confirmation) => this.handleGroupActionIconClick(key, confirmation)}
                    checkedIds={checkedIds}
                    onCheckedIdsChange={(ids) => this.setState({ checkedIds: ids })}
                    showDeleted={showDeleted}
                    onShowDeletedChange={(val) => this.handleShowDeletedChange(val)}

                    sortKey={sortKey}
                    sortDir={sortDir}
                    onSortChange={(key, dir) => this.onSortChange(key, dir)}

                    currentPage={curPage}
                    totalRecords={total}
                    recordsPerPage={perPage}
                    onPageChange={(pageNo) => this.onPageChange(pageNo)}
                    onRecordsPerPageChange={(recordPerPage) => this.onRecordsPerPageChange(recordPerPage)}
                />

            </PrivateLayout>
        );
    }

}

export default OrdersScreen;
